import { useToast } from "../../ui";
import { useNextT } from "../../i18n";

/** "Saved" with Undo where there is one to undo (every setting saves by itself). */
export const useSavedToast = () => {
  const { t } = useNextT();
  const toast = useToast();
  return (undo?: () => void) =>
    toast(undo ? { message: t("settingsPage.saved"), actionLabel: t("ui.undo"), onAction: undo } : { message: t("settingsPage.saved") });
};

export const useFailedToast = () => {
  const { t } = useNextT();
  const toast = useToast();
  return () => toast({ message: t("settingsPage.save_failed"), tone: "danger" });
};
